import { render, staticRenderFns } from "./OptionTable.vue?vue&type=template&id=45c24fe4&scoped=true"
import script from "./OptionTable.vue?vue&type=script&lang=js"
export * from "./OptionTable.vue?vue&type=script&lang=js"
import style0 from "./OptionTable.vue?vue&type=style&index=0&id=45c24fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c24fe4",
  null
  
)

export default component.exports